export interface User {
    sub: string;        // User ID
    name?: string;
    email?: string;
    email_verified?: boolean;
    picture?: string;
    [key: string]: any; // Auth0 custom claims
}

export interface AuthState {
    isAuthenticated: boolean;
    user: User | null;
    accessToken: string | null;
    loading: boolean;
    error: string | null;
}

/**
 * Custom user metadata from Auth0 JWT claims
 * Available under the 'http://invintus_user_metadata' key
 */
export interface UserMetadata {
    clientID?: number;
    loginID?: number;
}
